import type { Maybe } from 'graphql/jsutils/Maybe';

// Converts the contentful optional array string type to string[]
export const convertDomains = (domains: Maybe<Maybe<string>[]> | undefined) => {
  const typedDomains: string[] = [];
  domains?.forEach((domain) => {
    if (typeof domain === 'string') {
      typedDomains.push(domain);
    }
  });

  return typedDomains;
};
